import { Policy } from 'shared';
import { EmployeeRole } from '../types/employee-role';
import { IEmployeePolicyRoles } from '../types/i-employee-policy-roles';

export class Employee {
    public employeeID: number;
    public name: string;
    public roles: string[];
    public storeCode: string;
    public region?: string;
    public authToken?: string;
    public passChangeForced?: boolean;

    constructor(private _policyRoles: IEmployeePolicyRoles[] = []) {}

    public hasRoles(searchedRoles: EmployeeRole[]): boolean {
        return (
            this.roles !== undefined &&
            this.roles.length > 0 &&
            searchedRoles.some((x) => this.roles.includes(EmployeeRole[x]))
        );
    }

    public can(policy: Policy): boolean {
        const policyRole = this._policyRoles.find((x) => x.policy === policy);

        return policyRole !== undefined && this.hasRoles(policyRole.roles);
    }
}
